const asciiArt = ` ++++++++++++++++++++++++++++++
++++++++++++++++++++++++++++++++
++++++++++++++++++++++++++++++++
++++++++++++++++---+++++++++++++
+++++++++++-...    ....-++++++++
+++++++++..   .....    -++++++++
++++++++.   .-++++-    -++++++++
+++++++-    -+++++-    -++++++++
+++++++.   .++++++-    -++++++++
+++++++.   .++++++.    -++++++++
+++++++.    .++++..    .++++++++
++++++++.     .. .-.   .++++++++
+++++++++.      .-+.    -+++++++
+++++++++++----+++++++++++++++++
++++++++++++++++++++++++++++++++
++++++++++++++++++++++++++++++++
 ++++++++++++++++++++++++++++++

Make a smart move https://www.akina.health/en/contact
 `;

export const akinaAsciiArt = () => {
  // eslint-disable-next-line no-console
  console.log(asciiArt);
};
